<template>
  <div class="news-headlines-detail">
        <!-- <newsHeader ></newsHeader> -->
        <!-- <el-breadcrumb separator="/" class="bread-crumb main">
            <el-breadcrumb-item :to="{ path: '/news' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: crumbPath }">{{crumbName}}</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/news/topic/list/'+ crumbTopicListId }" v-if="crumbName === '专题新闻'">专题列表</el-breadcrumb-item>
            <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
        </el-breadcrumb> -->
        <!-- <breadCrumb></breadCrumb> -->
        <div class="news-detail-wrapper main flex-between">
            <div class="news_detail_left">
                <div class="content-box">
                    <div class="title-box">
                        <h3 class="f18">{{article.title}}</h3>
                        <p class="source f12">
                            <span> 来源：{{article.source}}</span> 
                            <span> 作者：{{article.author}} </span>
                            <span> 责任编辑：{{article.editor}}</span> 
                            <!-- <span> 责任编辑：张璐 </span> -->
                        </p>
                        <p class="other-info f12 flex-layout">
                            <span>{{article.updateTime}}</span>
                            <span class="eye">{{article.views || 0}}</span>
                        </p>
                    </div>
                    <div class="content" v-html="article.content">
                         <!-- <p>
                             为全力做好疫情防控及应急处置工作，切实保障师生员工的健康和安全，
                            6月5日上午，我校组织开展学生返校演练。学校返校复课领导小组组长、
                            党委书记郑萼、校长孟繁华，领导小组成员、副校长杨志成、纪委书记李中奇、
                            副校长李有增、副校长马力耕、北京教育系统疫情防控工作领导小组驻我校联络员于杰进行观摩。
                            演练由党委副书记缪劲翔主持。
                        </p>
                        <p>
                            首先，孟繁华作返校演练动员讲话。
                            他表示，此次演练是对近期学校疫情防控工作的整体考核，
                            也是全面做好返校复学工作的关键一环。全校各单位要提高政治站位，
                            扎实守好每一个关口，树立“演练即是实战”思想，摸清问题短板，不断完善流程。
                            各单位、全体师生员工要同心同德、齐心协力，层层压实责任，营造良好氛围，
                            强化联防联控机制，举全校之力，迎接学生“回家”。
                         </p>
                        <img src="" alt=""> -->
                    </div>
                    <div class="pagination flex-align-between">
                       <p class="pv wes" :class="[!prev.id? 'not-hover' : '']" @click="toPage(prev)">上一篇：{{prev.id ? prev.title :'无'}}</p>
                       <p class="next wes" :class="[!next.id? 'not-hover' : '']" @click="toPage(next)">下一篇：{{next.id ? next.title :'无'}}</p>
                    </div>
                   
                </div>
            </div>
            <div class="news_detail_right">
                <div class="subtitle flex-align-between">
                    <h2 class="text text-first f16 flex-align">最新推荐</h2>
                </div>
                <div class="timeline-list">
                    <el-timeline>
                      <el-timeline-item
                        v-for="(activity, index) in activities"
                        :key="index"
                        type="primary"
                        color="#BEE3FF"
                        size="large"
                        :timestamp="activity.detailCreateTime"
                        class="timeline-item">
                        <p class="f12" @click="toPage(activity)">{{activity.detailCreateTime}}</p>
                        <p class="f12" @click="toPage(activity)">{{activity.introduction}}</p>
                      </el-timeline-item>
                    </el-timeline>
                </div>
            </div>
        </div>
        <scorllTop :share="false"></scorllTop>
  </div>
</template>

<script>
export default {
    data() {
        return {
        crumbPath:'',
        crumbName:'',
        crumbTopicListId:1,
        article:{},
        prev:{},
        next:{},
        hasHover:false,
        activities: [{
          content: {
              time:'2020.06.03',
              text:'首都教育远程互助工程“北京-银川”“互联网+教育” “双优云桥',
          },
        }, {
          content: {
              time:'2020.06.03',
              text:'首都教育远程互助工程“北京-银川”“互联网+教育” “双优云桥',
          },
          color: '#BEE3FF'
        }, {
          content: {
              time:'2020.06.03',
              text:'首都教育远程互助工程“北京-银川”“互联网+教育” “双优云桥',
          },
          color: '#BEE3FF'
        }, {
          content: {
              time:'2020.06.03',
              text:'首都教育远程互助工程“北京-银川”“互联网+教育” “双优云桥',
          },
          color: '#BEE3FF'
        },
        {
          content: {
              time:'2020.06.03',
              text:'首都教育远程互助工程“北京-银川”“互联网+教育” 首都师京-银川”“互联京-银川”“互联京-银川”“互联范大学“双优云桥',
          },
          color: '#BEE3FF'
        }]
        }
    },
     watch: {
       $route(to,from){
           document.body.scrollTop = 0
           document.documentElement.scrollTop = 0
        // console.log(to,from);
        // let _id = to.path.split('/')[_id.length - 1]
        // console.log(_id);
        // this.crumbTopicListId = _id
       }
    },
    computed:{

    },
    methods:{
        async getArticle() {
            let params = {
                id:this.$route.params.id
            }
            let resData = await Api.News.GetNewsDetail(params);
            this.article = resData.data;
            // console.log(resData);
        },

        async getRecommend() {
            let resData = await Api.News.GetNewsRecommend()
             console.log(resData);
            this.activities = resData.data;
        },

        async getNearInfo () {
            let params = {
                id:this.$route.params.id
            }
            let resData = await Api.News.GetNear(params);
            this.prev = resData.data[0];
            this.next = resData.data[1];
            //console.log(resData);
        },
        toPage(item){
            console.log(111)
            if(item.id !== undefined) {
                Common.goPage(`/news/headlines/detail/${item.id}`,this)
            } 
        }
    },
    mounted(){
        this.getArticle();
        this.getRecommend();
        this.getNearInfo();

        // console.log(this.$route);

        // let path = this.$route.path.split("/");
        // console.log(path[2]);
        // switch(path[2]) {
        //     case 'headlines':
        //        this.crumbName = '头条新闻'
        //        this.crumbPath = '/news/headlines'; 
        //        break;
        //     case 'composite':
        //        this.crumbName = '综合新闻'
        //        this.crumbPath = '/news/composite'; 
        //        break;
        //     case 'topic':
        //        this.crumbName = '专题新闻'
        //        this.crumbPath = '/news/topic'; 
        //        break;
        // }
    },
}
</script>

<style lang="less">
    @import "./less/news_headlines_detail.less";
</style>